

export default function JobSeeks()
{

    return(
        <div>
<h4>JobSeek</h4>

        </div>
    )
}